import React, { useCallback, useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { Modal } from '@pella/sash-framework';
import { getCookie, setCookie } from '../../../../utilities/functions';

const ExitIntent = ({ width = 800, heading, cookieName, children, signinModalOpen = false }) => {
	const exitIntentTimer = useRef(null);
	const initTimer = useRef(null);
	const [isOpen, setIsOpen] = useState(false);
	const [exitTriggered, setExitTriggered] = useState(false);

	useEffect(() => {
		if (getCookie(cookieName) == null) {
			// Check if it has been longer than 5 minutes
			exitIntentTimer.current = setTimeout(
				() => {
					setIsOpen(true);
					setExitTriggered(true);
				},
				5 * 60 * 1000
			);

			// Check if the mouse is moving out of the window
			initTimer.current = setTimeout(() => {
				document.addEventListener('mouseleave', trackMouseMove, {
					passive: true,
				});
			}, 7500);

			return () => {
				cleanup();
			};
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- preexisting failure, fix when possible
	}, []);

	useEffect(() => {
		if (exitTriggered) {
			setCookie(cookieName, true, 30 * 24 * 60 * 60 * 1000);
			cleanup();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps -- preexisting failure, fix when possible
	}, [exitTriggered]);

	const trackMouseMove = useCallback((e) => {
		if (!e.relatedTarget && e.clientY <= 0) {
			setIsOpen(true);
			setExitTriggered(true);
		}
	}, []);

	const cleanup = () => {
		document.removeEventListener('mouseleave', trackMouseMove, { passive: true });
		clearTimeout(exitIntentTimer.current);
		clearTimeout(initTimer.current);
		exitIntentTimer.current = null;
		initTimer.current = null;
	};

	const onModalClose = () => setIsOpen(false);

	return (
		<Modal
			isOpen={signinModalOpen ? false : isOpen}
			onClose={onModalClose}
			width={width}
		>
			{heading && <Modal.Header>{heading}</Modal.Header>}
			<Modal.Content>{children}</Modal.Content>
		</Modal>
	);
};

ExitIntent.propTypes = {
	children: PropTypes.node.isRequired,
	cookieName: PropTypes.string.isRequired,
	heading: PropTypes.string,
	width: PropTypes.number,
	signinModalOpen: PropTypes.bool,
};

export default ExitIntent;
